import {
  IProduct,
  ICMSApiResponse,
  BadgeImagesBySku,
  BadgeImageWithSku,
  EventEditionDetails,
  BadgeImage
} from "../../../../common/types";
import OfflineStorage from "../../../../common/offlineStorage/OfflineStorage";
import CMSHelper from "../../../../common/helpers/cms/CMSHelper";
import store from "../../../../redux/store";

export const useCmsImages = () => {
  const getLogosFromCms = async (products: IProduct[], eventEdition) => {
    const cmsEventDetails = store.getState().eventEdition.cmsEventDetails;
    for (const product of products) {
      const logoUrl = await fetchCmsImageUrl(product.sku, "logo", eventEdition, cmsEventDetails);
      toDataURL(logoUrl, () => {});
    }
  };

  function groupImagesBySku(products: IProduct[], badgeImagesWithSku: BadgeImageWithSku[]) {
    let badgeImagesBySku: BadgeImagesBySku[] = [];

    for (const product of products) {
      const imagesWithSku = badgeImagesWithSku.filter(badge => badge.sku === product.sku);
      let imagesBySku: BadgeImage[] = [];
      for (const badge of imagesWithSku) {
        imagesBySku = [...imagesBySku, { name: badge.name, base64Image: badge.base64Image }];
      }
      badgeImagesBySku = [...badgeImagesBySku, { sku: product.sku, images: imagesBySku }];
    }
    return badgeImagesBySku;
  }

  const getBadgeImagesFromCms = async (products: IProduct[], eventEdition) => {
    const cmsEventDetails = store.getState().eventEdition.cmsEventDetails;
    const imageNames = ["image2", "image3"];
    const eventProducts = products.filter(pr => pr.rx_event_edition_code === eventEdition.gbsCode);

    for (const product of eventProducts) {
      for (const imageName of imageNames) {
        const imageUrl = await fetchCmsImageUrl(product.sku, imageName, eventEdition, cmsEventDetails);
        toDataURL(imageUrl, () => {});
      }
    }
  };

  const getReceiptLogoUrl = async (locale: string) => {
    return CMSHelper.getReceiptLogoUrl(locale);
  };

  const getFreyaLogoUrl = (logoUrl, baseUrl) => {
    const NUMBER_OF_DIRECTORIES = 5;
    const splitLogoUrl = (logoUrl || '').split("/");
    const rmIndex = splitLogoUrl.indexOf("content");
    return `${baseUrl}/${splitLogoUrl
      .slice(rmIndex, rmIndex + NUMBER_OF_DIRECTORIES)
      .join("/")}/freya/logo.jpg/_jcr_content/renditions/original./123/logo.jpg`;
  };

  const readDataFromUrl = (callback, xhr: XMLHttpRequest) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      callback(reader.result);
    };
    reader.readAsDataURL(xhr.response);
  };

  const toDataURL = (url: string, callback) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = () => {
      readDataFromUrl(callback, xhr);
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  };

  const fetchCmsImageUrl = async (productSku: string, imageName: string, eventEdition, badgeLocation: ICMSApiResponse) => {
    const eventLogoUrl = badgeLocation.siteDetails?.logo?.url || '';
    const domain = new URL(eventEdition.domain || "").origin;

    return CMSHelper.getPortalImageUrl(eventLogoUrl, domain, imageName, productSku);
  };

  const fetchEventLogo = async (eventEdition: EventEditionDetails) => {
    if (!eventEdition.domain) {
      return;
    }
    const cmsEventDetails = store.getState().eventEdition.cmsEventDetails;
    const logoPath = cmsEventDetails?.siteDetails?.logo.url;
    const domain = new URL(eventEdition.domain || "").origin;
    const logoUrl = getFreyaLogoUrl(logoPath, domain);
    toDataURL(logoUrl, (base64Image: string) => {
      if (!base64Image || !Boolean(["png", "jpeg"].find(format => base64Image.toLowerCase().includes(`data:image/${format};`)))) return "";
      return OfflineStorage.addEventLogoToStorage(base64Image);
    });
  };

  const _forTestsOnly = { groupImagesBySku, fetchCmsImageUrl, toDataURL, readDataFromUrl };

  return { getLogosFromCms, getBadgeImagesFromCms, fetchEventLogo, _forTestsOnly, getReceiptLogoUrl };
};
